/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Atelier_ProposedInputs */

const en_scene_atelier_proposed = /** @type {(inputs: Scene_Atelier_ProposedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New date proposed`)
};

/**
* | output |
* | --- |
* | "New date proposed" |
*
* @param {Scene_Atelier_ProposedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_atelier_proposed = /** @type {((inputs?: Scene_Atelier_ProposedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Atelier_ProposedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_atelier_proposed(inputs)
});